const OBURmaDelete = () => {
  return (
    <>RmaDelete</>
  )
}

export default OBURmaDelete;